module.exports = "<!-- Authorization Checked -->"